import { Link } from 'react-router-dom';
import { Button, Space } from 'antd';
import { ApiOutlined, PlayCircleOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { EmptyState } from '@/components/EmptyState';

/**
 * The one sentence that names what starts a run (OPSFL-FLOWOPS-1 A3). A flow never "needs a
 * trigger" to be publishable or runnable: triggers are hub configuration wired after publish, and
 * any published flow can be started directly or via the product API.
 */
export const RUNS_EMPTY_TEACHING =
  'Runs start when a published flow is triggered — by you (Run on the Flows page), by an API call to ' +
  'POST /v1/runs, or by a wired trigger — clock, signal, alert rule.';

/** Both actions land on the Flows page: Run lives on its rows; `?triggers` opens the wiring hint there. */
export const RUNS_EMPTY_ACTION_TARGET = '/flows';
export const RUNS_EMPTY_TRIGGER_TARGET = '/flows?triggers';

export interface RunsEmptyStateProps {
  /** True when a status/flow filter is narrowing the index — the title says "match", not "yet". */
  filtered: boolean;
}

/** Runs-page empty state that teaches how a run begins and offers the two ways to make one. */
export function RunsEmptyState({ filtered }: RunsEmptyStateProps) {
  return (
    <EmptyState
      compact
      icon={<ThunderboltOutlined />}
      title={filtered ? 'No runs match' : 'No runs yet'}
      description={
        <>
          {filtered ? 'Nothing has run under these filters. ' : ''}
          {RUNS_EMPTY_TEACHING}
        </>
      }
      action={
        <Space wrap>
          <Link to={RUNS_EMPTY_ACTION_TARGET}>
            <Button type="primary" icon={<PlayCircleOutlined />}>
              Start a run
            </Button>
          </Link>
          <Link to={RUNS_EMPTY_TRIGGER_TARGET}>
            <Button icon={<ApiOutlined />}>Wire a trigger</Button>
          </Link>
        </Space>
      }
    />
  );
}
